// extracted by mini-css-extract-plugin
module.exports = {"wiki":"styles_wiki__1Nve6","items":"styles_items__Q9ceM","empty":"styles_empty__2zvPf"};